import AbstractSymbolSpineAnimationsConfig from "../../vendor_core/core/src/baseConfigs//AbstractSymbolSpineAnimationsConfig";
import ISymbolSpineAnimConfig from "../../vendor_core/core/src/managers/contracts/configurations/ISymbolSpineAnimConfig";
import ISpineAnimSkinConfig from "../../vendor_core/core/src/managers/contracts/configurations/spine_anim/ISpineAnimSkinConfig";
import ISpineAnimStateConfig from "../../vendor_core/core/src/managers/contracts/configurations/spine_anim/ISpineAnimStateConfig";

class SymbolSpineAnimationsConfig
    extends AbstractSymbolSpineAnimationsConfig
    implements ISymbolSpineAnimConfig
{
    name: string = "symbols";
    hasSkins: boolean = true;
    defaultSkin: string = "default";
    activeSkin: string = "default";
    defaultState: string = "idle";
    visible: boolean = true;
    states: ISpineAnimStateConfig[] = [
        {
            name: "idle",
            loop: false,
        },
        {
            name: "win",
            loop: true,
        },
        {
            name: "dark",
            loop: true,
        },
        {
            name: "darken",
            loop: false,
        },
        {
            name: "blur",
            loop: false,
        },
        {
            name: "end",
            loop: false,
        },
        {
            name: "fade",
            loop: false,
        },
        {
            name: "landing",
            loop: false,
        },
        {
            name: "black_hole_start",
            loop: false,
        },
        {
            name: "black_hole_loop",
            loop: true,
        },
        {
            name: "wild_burn_loop",
            loop: true,
        },
        {
            name: "wild_lock_start",
            loop: false,
        },

    ];
    skins: ISpineAnimSkinConfig[] = [
        {
            name: "default",
            states: [],
        },
        {
            name: "SYM_EMPTY",
            states: ["idle", "win", "blur"],
            chainingStates: [
                {
                    name: "expanding_chain",
                    states: ["black_hole_start", "black_hole_loop"],
                    entryPoint: "black_hole_start",
                    loop: true,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "black_hole_loop",
                },
            ],
            playDefault: true,
            defaultState: "idle",
        },
        {
            name: "F10",
            states: ["idle", "win", "blur"],
            chainingStates: [
                {
                    name: "expanding_chain",
                    states: ["black_hole_start", "black_hole_loop"],
                    entryPoint: "black_hole_start",
                    loop: true,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "black_hole_loop",
                },
            ],
            playDefault: true,
            defaultState: "idle",
        },
        {
            name: "F9",
            states: ["idle", "win", "blur"],
            chainingStates: [
                {
                    name: "expanding_chain",
                    states: ["black_hole_start", "black_hole_loop"],
                    entryPoint: "black_hole_start",
                    loop: true,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "black_hole_loop",
                },
            ],
            playDefault: true,
            defaultState: "idle",
        },
        {
            name: "F8",
            states: ["idle", "win", "blur"],
            chainingStates: [
                {
                    name: "expanding_chain",
                    states: ["black_hole_start", "black_hole_loop"],
                    entryPoint: "black_hole_start",
                    loop: true,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "black_hole_loop",
                },
            ],
            playDefault: true,
            defaultState: "idle",
        },
        {
            name: "F7",
            states: ["idle", "win", "blur"],
            chainingStates: [
                {
                    name: "expanding_chain",
                    states: ["black_hole_start", "black_hole_loop"],
                    entryPoint: "black_hole_start",
                    loop: true,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "black_hole_loop",
                },
            ],
            playDefault: true,
            defaultState: "idle",
        },
        {
            name: "F6",
            states: ["idle", "win", "blur"],
            chainingStates: [
                {
                    name: "expanding_chain",
                    states: ["black_hole_start", "black_hole_loop"],
                    entryPoint: "black_hole_start",
                    loop: true,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "black_hole_loop",
                },
            ],
            playDefault: true,
            defaultState: "idle",
        },
        {
            name: "M1",
            states: ["idle", "win", "blur"],
            chainingStates: [
                {
                    name: "expanding_chain",
                    states: ["black_hole_start", "black_hole_loop"],
                    entryPoint: "black_hole_start",
                    loop: true,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "black_hole_loop",
                },
            ],
            playDefault: true,
            defaultState: "idle",
        },
        {
            name: "M2",
            states: ["idle", "win", "blur"],
            chainingStates: [
                {
                    name: "expanding_chain",
                    states: ["black_hole_start", "black_hole_loop"],
                    entryPoint: "black_hole_start",
                    loop: true,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "black_hole_loop",
                },
            ],
            playDefault: true,
            defaultState: "idle",
        },
        {
            name: "M3",
            states: ["idle", "win", "blur"],
            chainingStates: [
                {
                    name: "expanding_chain",
                    states: ["black_hole_start", "black_hole_loop"],
                    entryPoint: "black_hole_start",
                    loop: true,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "black_hole_loop",
                },
            ],
            playDefault: true,
            defaultState: "idle",
        },
        {
            name: "M4",
            states: ["idle", "win", "blur"],
            chainingStates: [
                {
                    name: "expanding_chain",
                    states: ["black_hole_start", "black_hole_loop"],
                    entryPoint: "black_hole_start",
                    loop: true,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "black_hole_loop",
                },
            ],
            playDefault: true,
            defaultState: "idle",
        },
        {
            name: "M5",
            states: ["idle", "win", "blur"],
            chainingStates: [
                {
                    name: "expanding_chain",
                    states: ["black_hole_start", "black_hole_loop"],
                    entryPoint: "black_hole_start",
                    loop: true,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "black_hole_loop",
                },
            ],
            playDefault: true,
            defaultState: "idle",
        },
        {
            name: "WR",
            states: ["idle", "win", "blur", "landing"],
            chainingStates: [
                {
                    name: "lock_chain",
                    states: ["landing", "wild_lock_start", "wild_burn_loop"],
                    entryPoint: "landing",
                    loop: true,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "wild_burn_loop",
                },
            ],
            playDefault: true,
            defaultState: "idle",
        },
        {
            name: "BN1",
            states: ["idle", "win", "blur", "landing"],
            chainingStates: [
                {
                    name: "expanding_chain",
                    states: ["black_hole_start", "black_hole_loop"],
                    entryPoint: "black_hole_start",
                    loop: true,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "black_hole_loop",
                },
            ],
            playDefault: true,
            defaultState: "idle",
        },
        {
            name: "BN2",
            states: ["idle", "win", "blur", "landing"],
            chainingStates: [
                {
                    name: "expanding_chain",
                    states: ["black_hole_start", "black_hole_loop"],
                    entryPoint: "black_hole_start",
                    loop: true,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "black_hole_loop",
                },
            ],
            playDefault: true,
            defaultState: "idle",
        },
        {
            name: "BH",
            states: ["idle", "win", "blur", "landing"],
            chainingStates: [
                {
                    name: "expanding_chain",
                    states: ["black_hole_start", "black_hole_loop"],
                    entryPoint: "black_hole_start",
                    loop: true,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "black_hole_loop",
                },
            ],
            playDefault: true,
            defaultState: "idle",
        },
        {
            name: "FLAME",
            states: ["idle", "win", "blur", "landing"],
            chainingStates: [
                {
                    name: "expanding_chain",
                    states: ["black_hole_start", "black_hole_loop"],
                    entryPoint: "black_hole_start",
                    loop: true,
                    hideOnComplete: false,
                    hasStaticStateOnComplete: false,
                    hasLoopStateOnComplete: true,
                    loopStateOnComplete: "black_hole_loop",
                },
            ],
            playDefault: true,
            defaultState: "idle",
        },
    ];
}

export default new SymbolSpineAnimationsConfig();
